import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

export default function DashboardLayout({ children }) {
	return (
		<div id="main_dashboard" className="flex flex-col lg:h-screen lg:overflow-hidden">
			<Navbar />

			<div className="lg:flex lg:flex-1 lg:min-h-0">
				<Sidebar />
				<main className="flex-1 bg-bgColor md:px-[50px] p-6 min-w-0 lg:overflow-y-auto overflow-x-hidden">
					{/* For simple wrap usage */}
					{children}

					{/* For nested route usage */}
					<Outlet />
				</main>
			</div>
		</div>
	)
}